<app-quickscan-filter />
<app-quickscan-table />